<template>
  <v-container class="fill-height">
    <v-snackbar v-model="error" :top="true" :right="true" :vertical="true" color="error" :timeout="5000">
      Something went wrong. Please check the developer console!
      <v-btn dark text @click="error = false">
        Close
      </v-btn>
    </v-snackbar>
    <v-snackbar v-model="success" :top="true" :right="true" :vertical="true" color="success" :timeout="5000">
      Identifier successfully created
      <v-btn dark text @click="success = false">
        Close
      </v-btn>
    </v-snackbar>
    <v-card class="v-table-card" :elevation="3">
      <v-data-table
        :headers="getTableHeaders()"
        :items="getTableTranslations()"
        :loading="tableLoading"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-btn v-for="group in groups" :key="group.id" color="indigo" dark class="mb-1" @click="showTranslationsByGroup(group.id)">
              {{ group.name }}
            </v-btn>
            <div class="flex-grow-1"></div>
            <v-btn color="indigo" dark class="mb-1" @click="createDialog = true">
              Добави нов
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="props">
          <v-icon @click.native="handleTranslationEditClick(props.item)" small class="mr-2">mdi-pencil</v-icon>
          <v-icon @click.native="handleTranslationDeleteClick(props.item)" small>mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="createDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Добави идентификатор</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="isValid">
              <v-row>
                <v-col md="12">
                  <v-text-field name="title" prepend-icon="mdi-pencil" label="Име" v-model="name" :rules="[rules.required]" required></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="createDialog = false">Затвори</v-btn>
          <v-btn color="blue darken-1" text @click="handleAddIdentifierButtonClick">Добави</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editDialog" persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Идентификатор: {{ tabTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-tabs v-model="tab" background-color="transparent" @change="handleTabsChange">
              <v-tabs-slider></v-tabs-slider>
              <v-tab v-for="language in languages" :key="language.code" :href="'#' + language.code">
                {{ language.name }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
            <v-tab-item v-for="language in languages" :key="language.code" :value="language.code">
              <v-card flat color="basil">
                <v-form>
                  <v-row>
                    <v-col cols="12">
                      <v-textarea label="Some text" v-model="currentTranslation[language.code]" :value="tabContent"></v-textarea>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="editDialog = false; tabContent = null">Затвори</v-btn>
          <v-btn color="blue darken-1" text @click="handleEditTranslationClick">Редактирай</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { createIdentifier, createString, deleteIdentifier } from '@/repositories/translation.repository'
export default {
  data () {
    return {
      isValid: false,
      isEditFormValid: false,
      tableLoading: true,
      name: null,
      success: false,
      error: false,
      createDialog: false,
      editDialog: false,
      groupId: 2,
      tab: null,
      tabContent: null,
      tabTitle: null,
      currentTranslation: {},
      headers: [
        { text: 'Идентификатор', value: 'identifier', width: '20%' }
      ],
      rules: {
        required: value => !!value || 'Това поле е задължително!'
      }
    }
  },
  watch: {
    editDialog: function (newValue) {
      if (newValue) {
        this.tabContent = this.currentTranslation[this.tab]
      }
    }
  },
  created () {
      this.$store.dispatch('fetchLanguages');
      this.$store.dispatch('fetchGroups');

      this.showTranslationsByGroup(this.groupId);
  },
  computed: {
    languages () {
      return this.$store.state.language.languages
    },
    groups () {
      return this.$store.state.language.groups
    },
    identifiers () {
      return this.$store.state.language.groupIdentifiers
    },
    translations () {
      return this.$store.state.language.groupTranslations
    }
  },
  methods: {
    reset () {
      this.$refs.form.reset()
    },
    handleTabsChange () {
      this.tabContent = this.currentTranslation[this.tab]
    },
    handleTranslationDeleteClick (translation) {
      deleteIdentifier(translation.identifierId)
        .then(response => {
          const { success } = response.data
          this.success = success
          this.error = !this.success

          this.showTranslationsByGroup(this.groupId)
        }).catch(error => {
          console.log(error)
          this.error = true
          this.success = false
        })
    },
    handleEditTranslationClick () {
      for (const language of this.languages) {
        const content = this.currentTranslation[language.code]

        if (content != null) {
          this.createString(language.code, this.groupId, this.currentTranslation.identifierId, content)
        }
      }
    },
    createString (languageCode, groupId, identifierId, content) {
      createString(languageCode, groupId, identifierId, content)
        .then(response => {
          const { success } = response.data
          this.success = success
          this.error = !this.success

          this.showTranslationsByGroup(this.groupId)
          this.editDialog = false
          this.currentTranslation = {}
        }).catch(error => {
          console.log(error)
          this.error = true
          this.success = false
        })
    },
    getTableHeaders () {
        const headers = [...this.headers];
        for (const language of this.languages) {
            const languageObject = { text: language.name, value: language.code, width: '25%' };
            headers.push(languageObject);
        }

        headers.push({ text: 'Actions', value: 'actions', sortable: false, align: 'right', width: '3%' });
        return headers;
    },
    getTableTranslations () {
      const translations = [];
      for (const identifier of this.identifiers) {
        const identifierItem = {
          identifier: identifier.name,
          identifierId: identifier.id
        }

        for (const language of this.languages) {
          const translation = this.translations.find(translation => {
            if (!translation.language) {
              return false
            }

            return translation.identifier.name === identifier.name && translation.language.code === language.code
          })

          identifierItem[language.code] = translation ? translation.content : null
          identifierItem.translationId = translation ? translation.id : null
        }

        translations.push(identifierItem);
      }

      return translations
    },
    showTranslationsByGroup (groupId) {
      if (groupId !== this.groupId) {
        this.groupId = groupId
      }

      Promise.all([this.$store.dispatch('fetchTranslationsByGroup', groupId), this.$store.dispatch('fetchTranslationsIdentifiersByGroup', groupId)])
        .then(() => this.tableLoading = false);
    },
    handleTranslationEditClick (translation) {
      this.editDialog = true
      this.currentTranslation = translation

      this.tabTitle = translation.identifier
    },
    handleAddIdentifierButtonClick () {
      this.$refs.form.validate()
      if (!this.isValid) {
        return
      }

      try {
        createIdentifier(this.name, this.groupId)
          .then(response => {
            const { success } = response.data
            this.success = success
            this.error = !this.success

            this.reset()
            this.showTranslationsByGroup(this.groupId)
          }).catch(error => {
            console.log(error)
            this.error = true
            this.success = false
          })
      } catch (error) {
        console.log(error)
        this.error = true
        this.success = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-toolbar__content {
    button {
        margin-right: 15px;
        &:last-of-type {
          margin-right: 0;
        }
    }
}
</style>
